import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BlockErrors, CheckboxItem, InputGroupBase } from '@/components';
import { useResolveValue } from '@/hooks';
import { ValuesType } from '@/types';
import { getInputBlockAnswer } from '@/utils';
import { BlockLayout } from '../fragments/BlockLayout';
export const BooleanGroup = ({ block: { answer_no, answer_yes, id, images = [], key, layout }, defaultValue, errors = [], onChange }) => {
    const [resolver] = useResolveValue();
    const resolved = useMemo(() => {
        const answersList = [answer_yes, answer_no].map((a, order) => {
            return Object.assign(Object.assign({}, a), { label: resolver.resolveString(a.label), order });
        });
        return {
            answersList
        };
    }, []);
    const handleChange = (answer) => {
        const newAnswer = getInputBlockAnswer(ValuesType.BOOLEAN, answer, key);
        onChange(newAnswer, { order: answer.order });
    };
    return (_jsx(BlockErrors, Object.assign({ errors: errors }, { children: _jsx(BlockLayout, Object.assign({ layout: layout }, { children: _jsx(InputGroupBase, Object.assign({ "data-test": id }, { children: resolved.answersList.map((item) => {
                    const value = String(item.value);
                    const isChecked = defaultValue !== undefined && defaultValue !== null && value === String(defaultValue);
                    return (_jsx(CheckboxItem, { answer: item, answerChange: handleChange, images: images, isChecked: isChecked }, item.id));
                }) })) })) })));
};
